// CSS class constants and styling configuration
export const THEME_COLORS = {
  PRIMARY_GREEN: "green-600",
  PRIMARY_GREEN_HOVER: "green-700", 
  PRIMARY_GREEN_LIGHT: "green-50",
  GRAY_PRIMARY: "gray-700",
  GRAY_SECONDARY: "gray-600",
  GRAY_LIGHT: "gray-500",
  GRAY_VERY_LIGHT: "gray-100",
  WHITE: "white",
  BLACK: "black",
} as const;

export const BUTTON_STYLES = {
  PRIMARY: `bg-${THEME_COLORS.PRIMARY_GREEN} hover:bg-${THEME_COLORS.PRIMARY_GREEN_HOVER} text-${THEME_COLORS.WHITE}`,
  SECONDARY: `text-${THEME_COLORS.GRAY_PRIMARY} hover:text-${THEME_COLORS.PRIMARY_GREEN}`,
  ACTIVE: `text-${THEME_COLORS.PRIMARY_GREEN}`,
} as const;

export const LAYOUT_SPACING = {
  SECTION_PADDING_Y: "py-16",
  SECTION_PADDING_X: "px-4",
  CONTAINER_MAX_WIDTH: "max-w-7xl",
  CONTAINER_MARGIN: "mx-auto",
  HEADER_HEIGHT: "h-20",
  MOBILE_MENU_SPACE: "space-y-1",
  DESKTOP_NAV_SPACE: "space-x-8",
} as const;

export const RESPONSIVE_BREAKPOINTS = {
  MOBILE_HIDDEN: "hidden lg:flex",
  MOBILE_VISIBLE: "lg:hidden",
  DESKTOP_HIDDEN: "hidden lg:block",
  DESKTOP_VISIBLE: "lg:block",
} as const;

export const TRANSITION_CLASSES = {
  DEFAULT: "transition-colors",
  FAST: "transition-all duration-300 ease-in-out",
  SLOW: "transition-opacity duration-300",
  TRANSFORM: "transform transition-all duration-300 ease",
} as const;

export const SHADOW_CLASSES = {
  SMALL: "shadow-sm",
  MEDIUM: "shadow-lg",
  LARGE: "shadow-xl",
  CUSTOM_HEADER: "shadow-sm",
  CUSTOM_DROPDOWN: "shadow-lg",
} as const;